import {useContext} from 'react';
import { useParams } from 'react-router-dom';
import GlobalContext from "../context/GlobalContext.js";
import { CheckCircle2, XCircle, AlertCircle } from 'lucide-react';


export default function AllPayDDResult() {
    const {themeCSS, settings} = useContext(GlobalContext)
    const { result } = useParams();

    function closeModalForReactNative(){
        window.ReactNativeWebView.postMessage("Close Modal")
    }

    return (
        <div className={"min-h-screen " + (themeCSS.divCSS)}>
            <div className="flex flex-col items-center justify-center px-6" style={{ minHeight: '60vh' }}>
                {result === 'success' && (
                    <>
                        <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4">
                            <CheckCircle2 size={32} className="text-green-600" />
                        </div>
                        <p className="text-xl font-bold text-green-600 mb-2">Direct Debit Setup Successful</p>
                        <p className={`text-sm text-center mb-6 ${themeCSS.cardMuted || 'text-gray-500'}`}>
                            Your Direct Debit request has been sent successfully.
                        </p>
                    </>
                )}
                {result === 'existing' && (
                    <>
                        <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4">
                            <CheckCircle2 size={32} className="text-green-600" />
                        </div>
                        <p className="text-xl font-bold text-green-600 mb-2">Active Direct Debit Found</p>
                        <p className={`text-sm text-center mb-6 ${themeCSS.cardMuted || 'text-gray-500'}`}>
                            Your account already has an active Direct Debit.
                        </p>
                    </>
                )}
                {result === 'error' && (
                    <>
                        <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mb-4">
                            <AlertCircle size={32} className="text-red-500" />
                        </div>
                        <p className="text-xl font-bold text-red-500 mb-2">Something Went Wrong</p>
                        <p className={`text-sm text-center mb-6 ${themeCSS.cardMuted || 'text-gray-500'}`}>
                            Sorry, an error occurred. Please contact customer services.
                        </p>
                    </>
                )}
                {result === 'cancel' && (
                    <>
                        <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mb-4">
                            <XCircle size={32} className="text-red-500" />
                        </div>
                        <p className="text-xl font-bold text-red-500 mb-2">Direct Debit Cancelled</p>
                        <p className={`text-sm text-center mb-6 ${themeCSS.cardMuted || 'text-gray-500'}`}>
                            Direct Debit setup was cancelled.
                        </p>
                    </>
                )}
                <button
                    onClick={closeModalForReactNative}
                    className="px-8 py-3 rounded-xl text-sm font-semibold text-white"
                    style={{ backgroundColor: settings?.primary_hex_colour || '#1F2937' }}
                >
                    Done
                </button>
            </div>
        </div>
    );
}
